/* Bound both desktop menu columns to the visible viewport. Keep the flyout
   in its original DOM position so the theme's hover and focus handlers work. */
(function () {
  'use strict';

  var mq = window.matchMedia('(min-width: 990px)');
  var timer = null;
  var scope = null;
  var observer = null;
  var resizeObserver = null;
  var gutter = 16;
  var drawerStates = new WeakMap();

  function reset(dropdown, inner) {
    dropdown.removeAttribute('data-chrissie-menu-scroll');
    ['--chrissie-menu-height', '--chrissie-menu-top', '--chrissie-submenu-left', '--chrissie-submenu-width'].forEach(function (property) {
      dropdown.style.removeProperty(property);
    });
    inner.style.minHeight = '';
    dropdown.querySelectorAll('.header__nav-sublinks').forEach(function (submenu) {
      submenu.style.minHeight = '';
    });
  }

  function closeDrawer(header, drawer, focusDrawer) {
    var details = drawer.querySelector('details');
    var summary = drawer.querySelector('summary');
    if (!details || !summary) return;
    if (!details.hasAttribute('open') && !summary.classList.contains('menu-is-open')) return;
    var hadFocus = drawer.contains(document.activeElement);
    if (typeof drawer.instantlyHideDrawer === 'function') drawer.instantlyHideDrawer();
    details.removeAttribute('open');
    details.classList.remove('menu-opening', 'drawer-transitioning');
    drawer.querySelectorAll('.menu-is-open').forEach(function (button) {
      button.classList.remove('menu-is-open');
      button.setAttribute('aria-expanded', 'false');
    });
    summary.setAttribute('aria-expanded', 'false');
    header.classList.remove('menu-open');
    var anotherDrawerOpen = document.querySelector('.drawer__container.menu-opening');
    if (anotherDrawerOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.removeProperty('overflow');
      document.body.style.removeProperty('width');
      document.body.classList.remove('drawer--is-open');
    }
    if (hadFocus && !anotherDrawerOpen) {
      var firstLink = focusDrawer ? summary : scope.querySelector('.header__nav-link');
      if (firstLink) firstLink.focus({ preventScroll: true });
    }
  }

  function syncNavigation() {
    var header = scope.closest('.header');
    var nav = scope.closest('.header__nav');
    var drawer = header && header.querySelector('.header__drawer');
    if (!header || !nav || !drawer) return false;
    if (header.classList.contains('header--nav-drawer')) return true;
    if (!drawerStates.has(drawer)) drawerStates.set(drawer, drawer.classList.contains('mobile-drawer'));

    /* Measure the original desktop grid synchronously, including when its
       drawer fallback is active. No hidden clone or duplicated links. */
    header.removeAttribute('data-chrissie-nav-drawer');
    header.removeAttribute('data-chrissie-nav-compact');
    if (!mq.matches) {
      drawer.classList.toggle('mobile-drawer', drawerStates.get(drawer));
      if (!drawer.querySelector('details[open]')) closeDrawer(header, drawer, true);
      return false;
    }

    function fits() {
      var style = window.getComputedStyle(scope);
      var items = Array.from(scope.children);
      var width = items.reduce(function (sum, item) {
        return sum + item.getBoundingClientRect().width;
      }, 0);
      width += (parseFloat(style.columnGap) || 0) * Math.max(0, items.length - 1);
      width += (parseFloat(style.paddingLeft) || 0) + (parseFloat(style.paddingRight) || 0);
      return width <= nav.getBoundingClientRect().width + 1;
    }

    if (!fits()) header.setAttribute('data-chrissie-nav-compact', '');
    var useDrawer = !fits();
    drawer.classList.toggle('mobile-drawer', drawerStates.get(drawer) && !useDrawer);
    if (useDrawer) {
      header.setAttribute('data-chrissie-nav-drawer', '');
      scope.querySelectorAll('.is-visible').forEach(function (menu) { menu.classList.remove('is-visible'); });
      header.classList.remove('is-megamenu-open');
      if (!drawer.querySelector('details[open]')) closeDrawer(header, drawer, true);
    } else {
      closeDrawer(header, drawer);
    }
    return useDrawer;
  }

  function sync() {
    if (!scope) return;
    var useDrawer = syncNavigation();

    var viewport = window.visualViewport;
    var leftEdge = viewport ? viewport.offsetLeft : 0;
    var rightEdge = leftEdge + (viewport ? viewport.width : document.documentElement.clientWidth);
    var bottomEdge = (viewport ? viewport.offsetTop + viewport.height : window.innerHeight);
    var rootSize = parseFloat(window.getComputedStyle(document.documentElement).fontSize) || 10;
    var preferredWidth = 24 * rootSize;

    scope.querySelectorAll('.header__nav-item.dropdown .header__nav-dropdown-inner').forEach(function (inner) {
      var dropdown = inner.closest('.header__nav-dropdown');
      if (!dropdown) return;
      if (!mq.matches || useDrawer) {
        reset(dropdown, inner);
        return;
      }
      if (!dropdown.getClientRects().length) return;

      var rect = inner.getBoundingClientRect();
      var height = Math.max(0, Math.floor(bottomEdge - rect.top - gutter));
      dropdown.style.setProperty('--chrissie-menu-height', height + 'px');
      dropdown.setAttribute('data-chrissie-menu-scroll', '');

      /* A native scrollbar can change the first column's width. Measure
         its edge only after the height limit has taken effect. */
      rect = inner.getBoundingClientRect();
      var roomRight = Math.max(0, rightEdge - rect.right - gutter);
      var roomLeft = Math.max(0, rect.left - leftEdge - gutter);
      var rtl = window.getComputedStyle(inner).direction === 'rtl';
      var onRight = !rtl;
      var preferredRoom = onRight ? roomRight : roomLeft;
      var otherRoom = onRight ? roomLeft : roomRight;
      if (preferredRoom < preferredWidth && otherRoom > preferredRoom) onRight = !onRight;
      var width = Math.min(preferredWidth, onRight ? roomRight : roomLeft);
      var left = onRight ? rect.right : rect.left - width;

      dropdown.style.setProperty('--chrissie-menu-top', rect.top + 'px');
      dropdown.style.setProperty('--chrissie-submenu-left', left + 'px');
      dropdown.style.setProperty('--chrissie-submenu-width', width + 'px');

      /* Max-height applies to both columns even without an open flyout.
         Reset only minimum heights before measuring; preserve scrollTop. */
      inner.style.minHeight = '0px';
      dropdown.querySelectorAll('.header__nav-sublinks').forEach(function (submenu) {
        submenu.style.minHeight = '0px';
      });
      var open = dropdown.querySelector('.header__nav-sublinks.is-visible');
      if (open) {
        var target = Math.min(Math.max(inner.scrollHeight, open.scrollHeight), height);
        inner.style.minHeight = target + 'px';
        open.style.minHeight = target + 'px';
      }
    });
  }

  function schedule() {
    if (timer !== null) return;
    timer = window.setTimeout(function () {
      timer = null;
      sync();
    }, 0);
  }

  function start() {
    var nextScope = document.querySelector('.header__nav-items');
    if (nextScope === scope) {
      schedule();
      return;
    }
    if (observer) observer.disconnect();
    if (resizeObserver) resizeObserver.disconnect();
    if (scope) {
      scope.removeEventListener('pointerover', schedule);
      scope.removeEventListener('pointerleave', schedule);
      scope.removeEventListener('focusin', schedule);
    }
    scope = nextScope;
    if (!scope) return;

    if (window.MutationObserver) {
      observer = new MutationObserver(schedule);
      observer.observe(scope, { attributes: true, attributeFilter: ['class'], subtree: true });
    }
    if (window.ResizeObserver) {
      resizeObserver = new ResizeObserver(schedule);
      var header = scope.closest('.header');
      resizeObserver.observe(header || scope);
      if (header) {
        header.querySelectorAll('.header__logo, .header__utils').forEach(function (part) { resizeObserver.observe(part); });
      }
    }
    scope.addEventListener('pointerover', schedule);
    scope.addEventListener('pointerleave', schedule);
    scope.addEventListener('focusin', schedule);
    schedule();
  }

  if (document.fonts) {
    document.fonts.ready.then(schedule);
    document.fonts.addEventListener('loadingdone', schedule);
  }
  window.addEventListener('resize', schedule);
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('shopify:section:load', start);
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', schedule);
    window.visualViewport.addEventListener('scroll', schedule, { passive: true });
  }
  if (mq.addEventListener) mq.addEventListener('change', schedule);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
